import { UserGroupIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

export type {
  FeatureCrudPermissions,
  FeatureMetadata,
  FeatureNavigationMeta,
  FeatureRouteMeta,
} from "../../feature.types";

import type { FeatureMetadata } from "../../feature.types";

export const StudentsV2Feature: FeatureMetadata = {
  id: "students-v2",
  moduleName: "academics",
  guardianNavigation: {
    label: "My Children",
    order: 2,
  },
  navigation: {
    label: "Students V2",
    path: "/students-v2",
    icon: UserGroupIcon,
    order: 1,
  },
  route: {
    path: "/students-v2/*",
    element: lazy(() => import("./pages/StudentsV2")),
  },
  permissions: {
    view: "Academics.Students.view",
    create: "Academics.Students.create",
    edit: "Academics.Students.edit",
    delete: "Academics.Students.delete",
  },
  readiness: "live",
};
